import { IsEmail, IsNotEmpty, IsString, MinLength } from "class-validator";

export class AdminResetPasswordDto {
  @IsEmail()
  @IsNotEmpty()
  email: string;

  @IsString()
  @IsNotEmpty()
  @MinLength(8)
  new_password: string;
}
